import styled from '@emotion/styled';
import { ButtonWithIcon } from '@kyruus/button';

export const StyledSearchAreaButton = styled(ButtonWithIcon)`
  z-index: 2;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 16px;
`;
